module.exports = __webpack_public_path__ + "img/barcodeButton.c4967184.svg";